import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-self: center;
  margin-top: 2rem;
  padding-bottom: 0.5rem;
  width: 90%;

  ${themeGet('breakpoints.large')} {
    width: 85%;
  }

  ${themeGet('breakpoints.medium')} {
    width: 90%;
  }

  ${themeGet('breakpoints.tablet')} {
    width: 95%;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  ${themeGet('breakpoints.mobile')} {
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
  }
`
